import getConfig from 'next/config'

export const requestUrl = (userId) => {
  const { publicRuntimeConfig } = getConfig()
  const { PEEKABOO_API_URL } = publicRuntimeConfig

  return userId ? `${PEEKABOO_API_URL}/${userId}` : PEEKABOO_API_URL
}

const requestInit = (domain, userAttributes) => {
  const defaultRequestInit: RequestInit = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-domain': domain,
      'x-href': window.location.href,
      'x-host': window.location.host,
      'x-pathname': window.location.pathname,
      'x-search': window.location.search,
    },
  }

  const hasAttributes = !!userAttributes
  if (hasAttributes) {
    return {
      method: 'post',
      body: JSON.stringify({ userAttributes: userAttributes }),
      ...defaultRequestInit,
    }
  }

  return defaultRequestInit
}

export const fetchExperiments = async (userId, userAttributes, domain) => {
  const init = requestInit(domain, userAttributes)
  const response = await fetch(requestUrl(userId), init)
  const json = await response.json()

  return json
}

export const removeKeyForUndefinedValues = (obj: object) =>
  Object.keys(obj).reduce((acc, key) => {
    if (typeof obj[key] !== 'undefined') {
      acc[key] = obj[key]
    }
    return acc
  }, {})
